var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ak-form-decorator",
    {
      attrs: {
        id: _vm.id,
        title: _vm.title,
        helpText: _vm.helpText,
        error: _vm.error,
        hasError: _vm.hasError,
        required: true,
        value: _vm.value,
        hidden: _vm.hidden,
        errorLocales: _vm.errorLocales,
      },
    },
    [
      _c("div", { staticClass: "ak-form__address" }, [
        _c("div", { staticClass: "ak-form__address-fields" }, [
          _c(
            "div",
            {
              staticClass:
                "ak-form__address-field ak-form__address-field--street",
            },
            [
              _c(
                "ak-input-text",
                _vm._g(
                  {
                    attrs: {
                      id: "street",
                      placeholder: _vm.$t("Straatnaam"),
                      required: _vm.required,
                      "read-only": _vm.readOnly,
                    },
                    model: {
                      value: _vm.localAddress.street,
                      callback: function ($$v) {
                        _vm.$set(_vm.localAddress, "street", $$v)
                      },
                      expression: "localAddress.street",
                    },
                  },
                  _vm.$currentListeners
                )
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "ak-form__address-field ak-form__address-field--number",
            },
            [
              _c(
                "ak-input-text",
                _vm._g(
                  {
                    attrs: {
                      id: "streetNumber",
                      placeholder: _vm.$t("Nummer"),
                      required: _vm.required,
                      "read-only": _vm.readOnly,
                    },
                    model: {
                      value: _vm.localAddress.streetNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.localAddress, "streetNumber", $$v)
                      },
                      expression: "localAddress.streetNumber",
                    },
                  },
                  _vm.$currentListeners
                )
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.hideBusNumber
            ? _c(
                "div",
                {
                  staticClass:
                    "ak-form__address-field ak-form__address-field--extra",
                },
                [
                  _c("ak-input-text", {
                    attrs: {
                      id: "extra",
                      placeholder: _vm.$t("Bus"),
                      "read-only": _vm.readOnly,
                    },
                    model: {
                      value: _vm.localAddress.extra,
                      callback: function ($$v) {
                        _vm.$set(_vm.localAddress, "extra", $$v)
                      },
                      expression: "localAddress.extra",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ak-form__address-fields" }, [
          _c(
            "div",
            {
              staticClass:
                "ak-form__address-field ak-form__address-field--postalcode",
            },
            [
              _c(
                "ak-input-text",
                _vm._g(
                  {
                    attrs: {
                      id: "postalCode",
                      placeholder: _vm.$t("Postcode"),
                      required: _vm.required,
                      "read-only": _vm.readOnly,
                    },
                    model: {
                      value: _vm.localAddress.postalCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.localAddress, "postalCode", $$v)
                      },
                      expression: "localAddress.postalCode",
                    },
                  },
                  _vm.$currentListeners
                )
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "ak-form__address-field ak-form__address-field--city",
            },
            [
              _c(
                "ak-input-text",
                _vm._g(
                  {
                    attrs: {
                      id: "city",
                      placeholder: _vm.$t("Stad"),
                      required: _vm.required,
                      "read-only": _vm.readOnly,
                    },
                    model: {
                      value: _vm.localAddress.city,
                      callback: function ($$v) {
                        _vm.$set(_vm.localAddress, "city", $$v)
                      },
                      expression: "localAddress.city",
                    },
                  },
                  _vm.$currentListeners
                )
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ak-form__address-fields" }, [
          _c(
            "div",
            {
              staticClass:
                "ak-form__address-field ak-form__address-field--province",
            },
            [
              _c(
                "ak-input-text",
                _vm._g(
                  {
                    attrs: {
                      id: "province",
                      placeholder: _vm.$t("Provincie"),
                      required: _vm.required,
                      "read-only": _vm.readOnly,
                    },
                    model: {
                      value: _vm.localAddress.province,
                      callback: function ($$v) {
                        _vm.$set(_vm.localAddress, "province", $$v)
                      },
                      expression: "localAddress.province",
                    },
                  },
                  _vm.$currentListeners
                )
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "ak-form__address-field ak-form__address-field--country",
          },
          [
            _vm.activeCountryOptions
              ? _c(
                  "ak-select",
                  _vm._g(
                    {
                      attrs: {
                        id: "country",
                        placeholder: _vm.$t("land"),
                        required: _vm.required,
                        selectOptions: _vm.activeCountryOptions,
                        "read-only": _vm.readOnly,
                      },
                      model: {
                        value: _vm.localAddress.country,
                        callback: function ($$v) {
                          _vm.$set(_vm.localAddress, "country", $$v)
                        },
                        expression: "localAddress.country",
                      },
                    },
                    _vm.$currentListeners
                  )
                )
              : _c(
                  "ak-input-text",
                  _vm._g(
                    {
                      attrs: {
                        id: "country",
                        placeholder: _vm.$t("land"),
                        required: _vm.required,
                        "read-only": _vm.readOnly,
                      },
                      model: {
                        value: _vm.localAddress.country,
                        callback: function ($$v) {
                          _vm.$set(_vm.localAddress, "country", $$v)
                        },
                        expression: "localAddress.country",
                      },
                    },
                    _vm.$currentListeners
                  )
                ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.showMap && _vm.googleApiKey
          ? _c(
              "div",
              {
                staticClass: "ak-form__address-map-wrapper",
                class: {
                  "ak-form__address-map-wrapper--overlay":
                    !_vm.localAddress.lat && !_vm.localAddress.lng,
                  "ak-form__address-map-wrapper--hover":
                    _vm.localAddress.lat && _vm.localAddress.lng,
                },
              },
              [
                _c("div", { ref: "map", staticClass: "ak-form__address-map" }),
                _vm._v(" "),
                _c(
                  "ak-button",
                  {
                    staticClass: "ak-form__address-map-button",
                    class: {
                      "ak-form__address-map-button--bottom":
                        _vm.localAddress.lat && _vm.localAddress.lng,
                    },
                    attrs: { outlined: true, size: "small" },
                    on: { click: _vm.getLatLng },
                  },
                  [
                    _c("i", { staticClass: "ak-icon ak-button__icon" }, [
                      _vm._v("location_on"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("Locatie bepalen")))]),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }